var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#582270",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XmrB1L.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,1.17A1.74,1.74,0,0,1,4.85.29a1.41,1.41,0,0,1,1.71,0L6.79.5l8.4,8.41a1.39,1.39,0,0,1,.42,1.54,1.64,1.64,0,0,1-.39.59Q11,15.3,6.75,19.54A2.08,2.08,0,0,1,6,20H5.43c-.18-.09-.38-.17-.56-.28a1.57,1.57,0,0,1-.57-.89v-.47a2.44,2.44,0,0,1,.75-1.09l7.09-7.1a1.43,1.43,0,0,1,.23-.16,1.92,1.92,0,0,1-.23-.19Q8.58,6.28,5.05,2.73A2.49,2.49,0,0,1,4.3,1.64Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f23de1207b7635a0b9cdbdfbd5dc98b9.svg";
export { ForwardRef as ReactComponent };